module.exports = __webpack_public_path__ + "static/media/punches.ee57670e.mp4";